// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3iyAd","colMaxWidth":"Table_colMaxWidth__1fiUl"};